<template>
  <div v-resize="onResize" class="full-height full-width">
    <portal-target
      :class="{ 'full-height full-width': isMobile }"
      multiple
      :name="draggableTo"
    >
    </portal-target>
  </div>
</template>

<script>
import { getUUIDv4 } from '@utils'

import PopupMixins from './container-popup.mixins'
import SidebarMixins from './container-sidebar.mixins'
export default {
  mixins: [PopupMixins, SidebarMixins],
  components: {},
  props: {
    mapId: { type: String },
    width: { type: Number },
    height: { type: Number },
    prefix: { type: String, default: 'mapbox' },
  },
  data: () => ({
    parentHeight: 0,
    parentWidth: 0,
    dragId: '',
    show: false,
  }),
  provide() {
    return {
      prefix: this.prefix,
    }
  },
  created() {
    this.dragId = getUUIDv4()
    //FIXME: Sửa cứng cho cho hiển thị lần đầu luôn xuất hiện ở góc
    this.show = true
    this.$nextTick(() => {
      this.show = false
    })
  },
  mounted() {
    this.onResize()
  },
  computed: {
    draggableTo() {
      return `${this.mapId || this.dragId}-map-draggable`
    },
  },
  methods: {},
}
</script>

<style scoped></style>
